import { render, staticRenderFns } from "./user-menu-mobile.vue?vue&type=template&id=3bf2da86&scoped=true"
import script from "./user-menu-mobile.vue?vue&type=script&lang=ts"
export * from "./user-menu-mobile.vue?vue&type=script&lang=ts"
import style0 from "./user-menu-mobile.vue?vue&type=style&index=0&id=3bf2da86&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2da86",
  null
  
)

export default component.exports